import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pesem in ples",
  "description": "",
  "published": "2007-03-27T00:00:00.000Z",
  "redirect_from": ["/blog/pesem-in-ples/swizec/252"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ob vcerajsnji vrnitvi v svoje domovanje in preverjanju `}<a parentName="p" {...{
        "href": "http://myspace.com/swizec"
      }}>{`myspace`}</a>{`, kar se verjeli ali ne obcasno pripeti, me je pozdravilo sporocilo enega`}<a parentName="p" {...{
        "href": "http://profile.myspace.com/index.cfm?fuseaction=user.viewprofile&friendid=58513191"
      }}>{` Lionel Lodge`}</a>{`. Ponujal je svojo novo pesem o `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Adrian_Monk"
      }}>{`Monku`}</a>{` vsem ljubiteljem zastonj, se pravi komurkoli. Pesmi sicer se nisem uspel prisluhniti, ampak se mi zdi zelo prijazna gesta, da v sodobnem svetu nekdo ponudi nekaj takega kot glasba zastonj, pa ceprav iz cisto promocijskih namenov.`}</p>
    <p>{`Stvar, ki pa trenutno grize moje zivce, je solsko popolno pomanjkanje zanimanja za ucence, ki bi morebiti potrebovali tipkovnico za pravo hitro tipkanje in jih ne zanima smrtonosni valcek ob vsakem pritisku na tipko.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      